import { AvForm } from 'availity-reactstrap-validation';
import { Modal, ModalHeader, ModalBody, Button, Row, Col, Alert } from 'reactstrap';

export const BtnModal = ({
  btnClass,
  btnIcon,
  btnColor,
  modalSize,
  modalSizeExtra = null,
  btnLabel,
  modalTitle,
  modalBtnLabel,
  modalBtnLabelDisplay = true,
  modalOpen,
  toggleModal,
  handleNewClick,
  handleSubmit,
  errorMsg,
  children
}) => {
  return (
    <>
      {btnLabel && (
        <Button
          color={btnColor}
          className='btn btn-primary'
          id={`${btnClass}`}
          onClick={handleNewClick}
        >
          <i className={`mdi ${btnIcon} me-1`} />
          {btnLabel}
        </Button>
      )}
      <Modal size={modalSize} className={modalSizeExtra} autoFocus={false} isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal} tag='h4'>
          {modalTitle}
        </ModalHeader>
        <ModalBody>
          {errorMsg !== '' && errorMsg ? ( <Alert color="danger"> {" "} {errorMsg}{" "} </Alert> ) : null}
          {modalBtnLabelDisplay ? (
            <AvForm onValidSubmit={handleSubmit}>
              {children}

              <Row>
                <Col>
                  <div className="text-end">
                    <button className="btn btn-success save-user">
                      {modalBtnLabel}
                    </button>
                  </div>
                </Col>
              </Row>
            </AvForm>
          ) : (
            <>
              {children}
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}